import React from 'react';

interface EstadoVazioProps {
  icone?: string;
  titulo: string;
  descricao?: string;
  acao?: React.ReactNode;
}

const EstadoVazio: React.FC<EstadoVazioProps> = ({ icone = 'bi bi-inbox', titulo, descricao, acao }) => (
  <div className='mc-estado mc-estado--vazio'>
    <i className={icone} />
    <strong>{titulo}</strong>
    {descricao && <p>{descricao}</p>}
    {acao}
  </div>
);

export default EstadoVazio;
